import { render } from "./FileDownloadTesting.vue?vue&type=template&id=3b736284&scoped=true"
import script from "./FileDownloadTesting.vue?vue&type=script&lang=js"
export * from "./FileDownloadTesting.vue?vue&type=script&lang=js"

import "./FileDownloadTesting.vue?vue&type=style&index=0&id=3b736284&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b736284"]])

export default __exports__